/* Lettoria NEVERMORE SALE — sticky checkout bar: "🛍 3 in your bag · $39.85 — Checkout →" (+ price-hold reminder).
 * WHY: Afroyla DD 09-25 — 522 add sessions → 93 purchases, checkout clicked only 129×; the drawer alone leaks.
 * Shows whenever the cart has items (also for returning shoppers). Repaints from:
 *   - 'lnm:added' on the page root (cart from the Horizon module → no extra GET; null → GET /cart.js)
 *   - Horizon 'cart:update' on document (drawer qty change / remove) → GET /cart.js (debounced)
 * Left side → /cart (full page, always fresh), right → /checkout. Mobile = bottom bar, desktop = centered pill.
 * Keys: header-cart / sticky-cta (registered in pixel store 3 vocabulary). Needs window.LNM. */
(function () {
  var A = window.LNM;
  if (!A) return;
  var root = A.root;
  var bar = root.querySelector('[data-lnm-bar]');
  if (!bar) return;
  var nEl = bar.querySelector('[data-lnm-bar-n]');
  var tEl = bar.querySelector('[data-lnm-bar-t]');
  var timer = null;

  function paint(cart) {
    if (!cart) return;
    var n = cart.item_count || 0;
    bar.hidden = n < 1;
    root.classList.toggle('has-bar', n > 0);
    nEl.textContent = n + (n === 1 ? ' item' : ' items');
    tEl.textContent = A.money((cart.total_price || 0) / 100);
  }

  function refresh() {
    clearTimeout(timer);
    timer = setTimeout(function () {
      fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(paint)
        .catch(function () {});
    }, 150);
  }

  root.addEventListener('lnm:added', function (e) {
    if (e.detail && e.detail.cart) paint(e.detail.cart);
    else refresh();
  });
  document.addEventListener('cart:update', refresh);
  refresh();
})();
